import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as businessPaymentRunProductDetailState from '../reducers';
import * as businessPaymentRunProductDetailReducer from '../reducers/business-payment-run-detail-product.reducer';

export const selectBusinessPaymentRunProductDetail = createSelector(
  businessPaymentRunProductDetailState.selectBusinessPaymentRunDetailProductState,
  businessPaymentRunProductDetailReducer.getBusinessPaymentRunDetailProducts
);
